import axios from "axios";
import { base_url, config } from "../../utils/axiosConfig";

// Sanitize input to prevent XSS attacks
const sanitizeInput = (input) => {
  if (typeof input === 'string') {
    return input
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;')
      .replace(/\//g, '&#x2F;');
  }
  return input;
};

// Sanitize contact data
const sanitizeContactData = (data) => {
  return {
    name: sanitizeInput(data.name),
    email: sanitizeInput(data.email),
    mobile: sanitizeInput(data.mobile),
    comment: sanitizeInput(data.comment)
  };
};

const postQuery = async (contactData) => {
  // Sanitize the contact data before sending
  const sanitizedData = sanitizeContactData(contactData);
  
  const response = await axios.post(`${base_url}enquiry`, sanitizedData);
  if (response.data) {
    return response.data;
  }
};

export const contactService = {
  postQuery,
};
